import { Injectable } from '@angular/core';

import { ProductYarnSpec, TmsWebBaseEditService } from 'tms-web-shared';

@Injectable({
  providedIn: 'root',
})
export class ProductYarnSpecService extends TmsWebBaseEditService<ProductYarnSpec, ProductYarnSpec> {
  constructor() {
    super('YarnSpec', $localize`Yarn Spec`);
  }
}
